import { AccountInfo } from '@azure/msal-browser';
import { createAction, props } from '@ngrx/store';
import { IPartner, IUser } from './user.models';

export const setUser = createAction(
  '[User] transform msal response to User',
  props<{ accountInfo: IUser }>()
);

export const setPartner = createAction(
  '[Partners] Set Partner',
  props<{ partner: IPartner }>()
);
